import * as Actions from "auth/store/actions";

const initialState = {
  success: false,
  isResendTokenLoading: false,
  errorResendToken: null,
  data: null,
};

const resendToken = (state = initialState, action) => {
  switch (action.type) {
    case Actions.RESEND_TOKEN_FETCH_START: {
      return {
        ...initialState,
        isResendTokenLoading: true,
      };
    }
    case Actions.RESEND_TOKEN_FETCH_SUCCESS: {
      return {
        ...initialState,
        success: true,
        isResendTokenLoading: false,
        data: action.payload.data,
      };
    }
    case Actions.RESEND_TOKEN_FETCH_FAILURE: {
      return {
        success: false,
        isResendTokenLoading: false,
        errorResendToken: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default resendToken;
